(function(){
  'use strict';
  var root=document.querySelector('[data-wheel]'); if(!root) return;
  var KEY_SEEN='mo_wheel_seen', KEY_WON='mo_wheel_won';
  function ls(k,v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k,v);}catch(e){ return null; } }
  var slices=[]; try{ slices=JSON.parse(root.querySelector('[data-wheel-slices]').textContent)||[]; }catch(e){}
  if(!slices.length) return;
  if(ls(KEY_WON)) return;
  var days=parseFloat(root.getAttribute('data-days'))||1, seen=parseInt(ls(KEY_SEEN)||'0',10);
  if(seen && Date.now()-seen < days*864e5) return;
  var pages=(root.getAttribute('data-pages')||'').split(',').map(function(s){return s.trim().replace(/\/+$/,'')||'/';}).filter(Boolean);
  var path=location.pathname.replace(/\/+$/,'')||'/';
  var ok=!pages.length||pages.some(function(p){ return p.slice(-1)==='*' ? path.indexOf(p.slice(0,-1))===0 : p===path; });
  if(!ok) return;

  /* ---- draw ---- */
  var canvas=root.querySelector('[data-wheel-canvas]'), ctx=canvas.getContext('2d');
  var segs=slices.concat(slices); /* 4 prizes shown twice, like the reference */
  var N=segs.length, arc=2*Math.PI/N, R=canvas.width/2;
  var css=getComputedStyle(document.documentElement);
  var gold=(css.getPropertyValue('--c-gold')||'#B08D57').trim(), paper=(css.getPropertyValue('--c-paper')||'#FCFAF6').trim(), ink=(css.getPropertyValue('--c-ink')||'#1C1A18').trim(), goldL=(css.getPropertyValue('--c-gold-light')||'#D6BE90').trim();
  function draw(){
    ctx.clearRect(0,0,canvas.width,canvas.height);
    for(var i=0;i<N;i++){
      var a0=i*arc, a1=a0+arc, odd=i%2===1;
      ctx.beginPath(); ctx.moveTo(R,R); ctx.arc(R,R,R-14,a0,a1); ctx.closePath();
      ctx.fillStyle=odd?gold:paper; ctx.fill();
      ctx.strokeStyle='rgba(0,0,0,.06)'; ctx.lineWidth=2; ctx.stroke();
      ctx.save(); ctx.translate(R,R); ctx.rotate(a0+arc/2); ctx.textAlign='right'; ctx.textBaseline='middle';
      ctx.fillStyle=odd?'#fff':ink; ctx.font='500 34px Jost, Helvetica, Arial, sans-serif';
      ctx.fillText(segs[i].label, R-44, 0); ctx.restore();
    }
    ctx.beginPath(); ctx.arc(R,R,R-8,0,2*Math.PI); ctx.lineWidth=14; ctx.strokeStyle=goldL; ctx.stroke();
    ctx.beginPath(); ctx.arc(R,R,R-1,0,2*Math.PI); ctx.lineWidth=2; ctx.strokeStyle=gold; ctx.stroke();
  }
  draw();

  /* ---- show / hide ---- */
  var shown=false, closed=false;
  function show(){ if(shown||closed) return; shown=true; root.hidden=false; document.body.classList.add('wheel-open'); try{ if(window.moProtect) window.moProtect(root.querySelector('[data-wheel-customer-form]')); }catch(x){} var e=root.querySelector('[data-wheel-email]'); if(e && window.innerWidth>800) setTimeout(function(){ try{e.focus();}catch(x){} },300); }
  function hide(){ root.hidden=true; document.body.classList.remove('wheel-open'); closed=true; ls(KEY_SEEN,String(Date.now())); }
  root.querySelectorAll('[data-wheel-close]').forEach(function(b){ b.addEventListener('click',function(){ if(spinning) return; hide(); }); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!root.hidden&&!spinning) hide(); });
  /* ---- triggers: engagement based, never on arrival ----
     mobile: time on page OR scroll depth; desktop: the same plus exit intent.
     Never interrupts an open cart, quiz or menu, or someone typing. */
  var mobile=window.matchMedia&&window.matchMedia('(max-width: 800px)').matches;
  var t0=Date.now(), FLOOR=8000;
  function busy(){
    if(document.querySelector('[data-cart-drawer].is-open,[data-quiz-modal].is-open,[data-mobile-nav].is-open')) return true;
    var a=document.activeElement; return !!(a&&/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)&&!root.contains(a));
  }
  function trigger(){
    if(shown||closed) return;
    var wait=FLOOR-(Date.now()-t0); if(wait>0){ setTimeout(trigger,wait); return; }
    if(busy()){ setTimeout(trigger,4000); return; }
    show();
  }
  var delay=parseFloat(root.getAttribute(mobile?'data-delay-mobile':'data-delay'));
  if(isNaN(delay)) delay=parseFloat(root.getAttribute('data-delay'));
  if(!isNaN(delay)) setTimeout(trigger, Math.max(0,delay)*1000);
  var pct=parseFloat(root.getAttribute('data-scroll'));
  if(!isNaN(pct)&&pct>0){ window.addEventListener('scroll',function onS(){ var max=document.documentElement.scrollHeight-window.innerHeight; if(max>0 && window.scrollY/max*100>=pct){ window.removeEventListener('scroll',onS); trigger(); } },{passive:true}); }
  if(!mobile && root.getAttribute('data-exit')==='true'){
    document.addEventListener('mouseout',function onX(e){ if(!e.relatedTarget && e.clientY<=0){ document.removeEventListener('mouseout',onX); trigger(); } });
  }

  /* ---- spin ---- */
  var spinning=false, form=root.querySelector('[data-wheel-form]'), err=root.querySelector('[data-wheel-error]');
  function pick(){ var tot=slices.reduce(function(s,x){return s+(+x.p||0);},0); if(tot<=0) return 0; var r=Math.random()*tot; for(var i=0;i<slices.length;i++){ r-=(+slices[i].p||0); if(r<0) return i; } return slices.length-1; }
  function subscribe(email,code){
    var cf=root.querySelector('[data-wheel-customer-form]'); if(!cf) return;
    ls('mo_lead_email',email); if(code) ls('mo_lead_code',code);
    /* tag the customer with the prize they won (spin-BELVORA10) so the welcome emails can quote their exact code */
    var tg=cf.querySelector('[name="contact[tags]"]'); if(tg) tg.value='newsletter,spin-to-win'+(code?',spin-'+code:'');
    /* Klaviyo: a "Spin to Win" event (public site key) starts the welcome emails with the exact code won */
    try{
      var pct=code?(code.match(/\d+/)||[''])[0]:'';
      var props={spin_code:code||'',spin_pct:pct,spin_source:'wheel'};
      fetch('https://a.klaviyo.com/client/events?company_id=UAZkBN',{method:'POST',keepalive:true,
        headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'event',attributes:{properties:props,
          metric:{data:{type:'metric',attributes:{name:'Spin to Win'}}},
          profile:{data:{type:'profile',attributes:{email:email,properties:props}}}}}})}).catch(function(){});
    }catch(x){}
    if(window.moSubscribe) window.moSubscribe(cf,email);
  }
  function applyCode(code){ try{ fetch('/discount/'+encodeURIComponent(code)+'?redirect=/',{credentials:'same-origin'}).catch(function(){}); }catch(e){} }
  form.addEventListener('submit',function(e){
    e.preventDefault(); if(spinning) return;
    var email=(root.querySelector('[data-wheel-email]').value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ err.hidden=false; return; }
    err.hidden=true; spinning=true; root.classList.add('is-spinning');
    var btn=root.querySelector('[data-wheel-spin]'); btn.disabled=true;
    var j=pick();
    subscribe(email,(slices[j]||{}).code);
    try{ if(window.moTrack) window.moTrack('Lead',{content_name:'Spin to win'}); }catch(e){}
    var vis=j+(Math.random()<0.5?0:slices.length);
    var arcDeg=360/N, jitter=(Math.random()-0.5)*arcDeg*0.6;
    var rot=360*6 - (vis+0.5)*arcDeg + jitter; /* pointer sits at 3 o'clock */
    canvas.style.transform='rotate('+rot+'deg)';
    setTimeout(function(){
      var s=slices[j];
      root.querySelector('[data-win-title]').textContent=s.title||'THANK YOU';
      root.querySelector('[data-win-text]').textContent=s.text||'';
      root.querySelector('[data-win-code]').textContent=s.code||'';
      root.querySelectorAll('[data-view]').forEach(function(v){ v.classList.toggle('is-active', v.getAttribute('data-view')==='win'); });
      ls(KEY_WON,s.code||'1'); ls(KEY_SEEN,String(Date.now()));
      if(s.code) applyCode(s.code);
      spinning=false; root.classList.remove('is-spinning');
    },5400);
  });
  var copy=root.querySelector('[data-win-copy]');
  if(copy) copy.addEventListener('click',function(){ var c=root.querySelector('[data-win-code]').textContent; try{ navigator.clipboard.writeText(c).then(function(){ copy.textContent='Copied'; setTimeout(function(){ copy.textContent='Copy'; },1800); }); }catch(e){} });
  var keep=root.querySelector('[data-wheel-keep]'); if(keep) keep.addEventListener('click',function(){ root.hidden=true; document.body.classList.remove('wheel-open'); });
})();
